import {API} from '../../Services';

async function FestivalDetailData(id){
    const token = localStorage.getItem('token');
    return API.get(`/campaigns/${id}`,{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}

async function WinnerData(id){
    const token = localStorage.getItem('token');
    return API.get(`/lottery/lottery_winner`,{
        params: {lottery_uid:id},
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}

async function TicketsData(id){
    const token = localStorage.getItem('token');
    return API.get(`/users/lottery_codes`,{
        params: {lottery_uid:id},
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}


export {FestivalDetailData,WinnerData,TicketsData};
